/* ==========================================================================
   Desktop Sticky Cart — IPA product drawer (parallel build).

   Faithful port of the existing cart's selectItem() + renderDrawerData() +
   claimGiftNew() (snippets/cart-revamp.liquid). Opens when an IPA / free-gift
   product card in the gift-unlock carousel is tapped, shows the product, and
   claims it via /cart/add.js with the freeGiftAOV property.

   Data sources (same as the existing flow):
     • the clicked gift object (the IPA-web/v2 item: image/title/price/
       compartAtPrice/priceTooltipText/vId/pId/handle/status/headerTitle + IPAData.AOV)
     • Storefront GraphQL metafield `custom.table_and_key_highlights` → Product Details
     • /products/<handle>.js → Product Description

   Exposes window.StickyCartIpaDrawer.open(item, { onClaim }).
   ========================================================================== */
(function () {
  'use strict';

  var GQL_URL = 'https://supertail.myshopify.com/api/2023-07/graphql.json';
  var GQL_TOKEN = '053259565522fc46f00e2ecb7f1cbe25';
  var DETAILS_VISIBLE = 4;   // rows shown before "View more"
  var DESC_LIMIT = 375;      // chars shown before "View more"

  function caretIcon(up) {
    return '<img src="https://cdn.shopify.com/s/files/1/0565/8021/0861/files/caret-down.png?v=1733568644" alt="' +
      (up ? 'Up' : 'Down') + ' Chevron" style="width: 12px; height: 12px;' +
      (up ? ' transform: rotate(180deg);' : '') + '">';
  }
  function viewMoreHtml(showLess) { return (showLess ? 'View less' : 'View more') + ' ' + caretIcon(showLess); }

  var root, claimHandler;

  function el(sel) { return root ? root.querySelector(sel) : null; }
  function setText(sel, v) { var e = el(sel); if (e) e.textContent = v == null ? '' : v; }

  function priceLabel(item) {
    var n = parseInt(item.price, 10);
    return isNaN(n) ? 'Free' : '₹' + item.price;
  }

  /* ---- Open / populate -------------------------------------------------- */
  function open(item, opts) {
    root = document.querySelector('[data-st-ipa]');
    if (!root || !item) return;
    opts = opts || {};

    // Image / title / price / MRP / badge.
    var img = el('[data-st-ipa-img]');
    if (img) { img.src = item.image || ''; img.alt = item.title || ''; }
    setText('[data-st-ipa-title]', item.title || '');
    setText('[data-st-ipa-price]', priceLabel(item));
    var mrp = el('[data-st-ipa-mrp]');
    if (mrp) mrp.innerHTML = item.compartAtPrice ? 'MRP <s>₹' + item.compartAtPrice + '</s>' : '';
    var badge = el('[data-st-ipa-badge]');
    if (badge) {
      if (item.priceTooltipText) { setText('[data-st-ipa-badge-text]', item.priceTooltipText); badge.hidden = false; }
      else badge.hidden = true;
    }

    // Reset the collapsible sections.
    el('[data-st-ipa-details]').innerHTML = '';
    el('[data-st-ipa-desc]').innerHTML = '';
    el('[data-st-ipa-details-head]').hidden = true;
    el('[data-st-ipa-desc-head]').hidden = true;

    // Claim vs Locked state (parity with renderDrawerData's switch). Locked shows a
    // purple "add items worth ₹X to unlock this" pill (item.headerTitle) above a
    // disabled "Locked" button.
    var claimBtn = el('[data-st-ipa-claim]');
    var lockedWrap = el('[data-st-ipa-locked]');
    var locked = item.status === 'Locked';
    if (claimBtn) claimBtn.hidden = locked;
    if (lockedWrap) lockedWrap.hidden = !locked;
    var lockedPill = el('[data-st-ipa-locked-pill]');
    if (lockedPill) {
      var msg = item.headerTitle || '';
      if (msg) { setText('[data-st-ipa-locked-msg]', msg); lockedPill.hidden = false; }
      else lockedPill.hidden = true;
    }
    resetClaimButton();

    // Know more → PDP.
    var knowmore = el('[data-st-ipa-knowmore]');
    if (knowmore) {
      knowmore.onclick = function () {
        if (item.handle) window.location.href = '/products/' + item.handle + (item.vId ? '?variant=' + item.vId : '');
      };
    }

    // Claim → /cart/add.js with freeGiftAOV, then refresh the drawer (no full reload).
    claimHandler = function () { claim(item, opts); };
    if (claimBtn) claimBtn.onclick = claimHandler;

    show();
    loadProductInfo(item);
    // Let the controller persist which IPA product drawer is open (for refresh / Back restore).
    try { document.dispatchEvent(new CustomEvent('stcart:ipa-opened', { detail: { vId: item.vId } })); } catch (e) {}
  }

  function show() {
    root.hidden = false;
    // Force reflow so the transition runs from the off-screen state (slide-in like the sticky cart).
    void root.offsetWidth;
    root.classList.add('is-open');
    document.body.classList.add('st-ipa-lock');
    document.addEventListener('keydown', onKey);
  }

  function close() {
    if (!root) return;
    try { document.dispatchEvent(new Event('stcart:ipa-closed')); } catch (e) {}
    root.classList.remove('is-open');
    document.body.classList.remove('st-ipa-lock');
    document.removeEventListener('keydown', onKey);
    var drawer = root.querySelector('.st-ipa__drawer');
    var done = function () { if (root) root.hidden = true; if (drawer) drawer.removeEventListener('transitionend', onEnd); };
    var onEnd = function (e) { if (e && e.target !== drawer) return; done(); };
    if (drawer) { drawer.addEventListener('transitionend', onEnd); setTimeout(done, 360); }
    else done();
  }

  function onKey(e) { if (e.key === 'Escape') close(); }

  /* ---- Product Details (metafields) XOR Description (product.js) --------- */
  function loadProductInfo(item) {
    // Storefront GraphQL for the table_and_key_highlights metafield.
    var query = 'query { product(id: "gid://shopify/Product/' + item.pId + '") { metafield(key: "table_and_key_highlights", namespace: "custom") { value } } }';
    fetch(GQL_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Shopify-Storefront-Access-Token': GQL_TOKEN },
      body: JSON.stringify({ query: query })
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        var raw = res && res.data && res.data.product && res.data.product.metafield && res.data.product.metafield.value;
        var rows = [];
        if (raw) { try { rows = JSON.parse(raw) || []; } catch (e) { rows = []; } }
        if (Array.isArray(rows) && rows.length) renderDetails(rows);
        else loadDescription(item.handle);
      })
      .catch(function () { loadDescription(item.handle); });
  }

  function renderDetails(rows) {
    var head = el('[data-st-ipa-details-head]');
    var box = el('[data-st-ipa-details]');
    if (!head || !box) return;
    head.hidden = false;

    function rowHtml(r) {
      return '<div class="st-ipa__row"><span class="st-ipa__row-k">' + escapeHtml(r.key) +
        '</span><span class="st-ipa__row-v">' + escapeHtml(r.value) + '</span></div>';
    }
    var shown = rows.slice(0, DETAILS_VISIBLE);
    var rest = rows.slice(DETAILS_VISIBLE);
    box.innerHTML = shown.map(rowHtml).join('');

    if (rest.length) {
      var more = document.createElement('button');
      more.type = 'button';
      more.className = 'st-ipa__viewmore';
      more.innerHTML = viewMoreHtml(false);
      var expanded = false;
      more.addEventListener('click', function () {
        expanded = !expanded;
        box.innerHTML = (expanded ? rows : shown).map(rowHtml).join('');
        box.appendChild(more);
        more.innerHTML = viewMoreHtml(expanded);
      });
      box.appendChild(more);
    }
  }

  function loadDescription(handle) {
    if (!handle) return;
    fetch('/products/' + handle + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (product) {
        var desc = cleanDescription(product && product.description);
        if (!desc) return;
        var head = el('[data-st-ipa-desc-head]');
        var box = el('[data-st-ipa-desc]');
        if (!head || !box) return;
        head.hidden = false;

        var full = desc;
        var truncated = desc.length > DESC_LIMIT;
        function render(showFull) {
          box.innerHTML = '<div class="st-ipa__desc-text">' + (showFull ? full : full.slice(0, DESC_LIMIT) + '…') + '</div>';
          if (truncated) {
            var btn = document.createElement('button');
            btn.type = 'button';
            btn.className = 'st-ipa__viewmore';
            btn.innerHTML = viewMoreHtml(showFull);
            btn.addEventListener('click', function () { render(!showFull); });
            box.appendChild(btn);
          }
        }
        render(!truncated);

        // Collapsible header toggle.
        head.onclick = function () {
          var hidden = box.style.display === 'none';
          box.style.display = hidden ? '' : 'none';
          head.classList.toggle('is-collapsed', !hidden);
        };
      })
      .catch(function () {});
  }

  function cleanDescription(html) {
    if (!html) return '';
    var tmp = document.createElement('div');
    tmp.innerHTML = html;
    Array.prototype.forEach.call(tmp.querySelectorAll('p'), function (p) {
      if (!p.textContent.trim()) p.remove();
    });
    return tmp.innerHTML.trim();
  }

  /* ---- Claim ------------------------------------------------------------- */
  function resetClaimButton() {
    var spinner = el('.st-ipa__claim-spinner');
    if (spinner) spinner.hidden = true;
    setText('[data-st-ipa-claim-text]', 'Claim');
    var claimBtn = el('[data-st-ipa-claim]');
    if (claimBtn) { claimBtn.disabled = false; claimBtn.classList.remove('is-claimed'); }
  }

  function claim(item, opts) {
    var claimBtn = el('[data-st-ipa-claim]');
    var spinner = el('.st-ipa__claim-spinner');
    if (claimBtn) claimBtn.disabled = true;
    if (spinner) spinner.hidden = false;
    setText('[data-st-ipa-claim-text]', 'Adding…');

    var aov = (item.IPAData && item.IPAData.AOV != null) ? item.IPAData.AOV : 0;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ items: [{ id: item.vId, quantity: 1, properties: { freeGiftAOV: aov } }] })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        // Limited stock (Figma 416-11641): Shopify returns 422 — show the notice + revert.
        if (data && data.status === 422) {
          resetClaimButton();
          notifyLimitedStock();
          return;
        }
        // Success → flip the CTA to a green "Claimed" state, then close + refresh
        // (Figma: CTA → "Claimed" → fades out after a few seconds).
        showClaimedState();
        setTimeout(function () {
          close();
          if (typeof opts.onClaim === 'function') opts.onClaim();
        }, 1400);
      })
      .catch(function (err) {
        if (window.console) console.error('[StickyCart] ipa-claim', err);
        resetClaimButton();
      });
  }

  // Turn the orange Claim button into the green "✓ Claimed" confirmation.
  function showClaimedState() {
    var claimBtn = el('[data-st-ipa-claim]');
    var spinner = el('.st-ipa__claim-spinner');
    if (spinner) spinner.hidden = true;
    if (claimBtn) { claimBtn.disabled = true; claimBtn.classList.add('is-claimed'); }
    setText('[data-st-ipa-claim-text]', 'Claimed');
  }

  function notifyLimitedStock() {
    var msg = 'Sorry, we have limited quantity available for this item!';
    if (window.StickyCart && typeof window.StickyCart.toast === 'function') {
      window.StickyCart.toast(msg, { error: true });
    } else if (window.alert) {
      window.alert(msg);
    }
  }

  function escapeHtml(s) {
    return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }

  // Backdrop / close buttons (the drawer markup is static in the shell).
  document.addEventListener('click', function (e) {
    if (e.target && e.target.closest && e.target.closest('[data-st-ipa-close]')) close();
  });

  window.StickyCartIpaDrawer = { open: open, close: close };
})();
